import { useState } from "react";
import WebsiteNavbar from "../components/WebsiteNavbar";
import Footer from "../components/Footer";
import api from "../services/api";
import "../style/commercial.css";

import { getErrorMessage } from "../utils/apiError";

const CommercialQuote = () => {

  const [form, setForm] = useState({
    company_name: "",
    contact_person: "",
    email: "",
    phone: "",
    project_location: "",
    bin_size: "",
    waste_type: "",
    requirements: ""
  });

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");
    setLoading(true);

    try {
      const res = await api.post("/commercial-quotes", form);
      setSuccess(res.data?.message || "Quote request submitted successfully.");
      setForm({
        company_name: "",
        contact_person: "",
        email: "",
        phone: "",
        project_location: "",
        bin_size: "",
        waste_type: "",
        requirements: ""
      });
    } catch (err) {
      setError(getErrorMessage(err, "Failed to submit quote request."));
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <WebsiteNavbar />

      <div className="cq-page">
        <section className="cq-hero">
  <span>COMMERCIAL QUOTES</span>
  <h1>Let's build the right waste solution for your business.</h1>
  
</section>
        <div className="cq-layout">

          {/* ── Left panel ── */}
          <aside className="cq-aside">
            <p className="comm-eyebrow" style={{ color: "#F5821F" }}>Commercial Enquiries</p>
            <h2>Let's build the right solution for your business.</h2>
            <p className="cq-aside-body">
              Tell us about your project and our commercial team will prepare a customised quote designed around your operational needs.
            </p>

            <div className="cq-trust-list">
              
              <div className="cq-trust-item">
                <span className="cq-trust-dot" />
                <span>Tailored Pricing Plans</span>
              </div>
              <div className="cq-trust-item">
                <span className="cq-trust-dot" />
                <span>Flexible Delivery Schedules</span>
              </div>
              <div className="cq-trust-item">
                <span className="cq-trust-dot" />
                <span>Same-day delivery options</span>
              </div>
              <div className="cq-trust-item">
                <span className="cq-trust-dot" />
                <span>Dedicated Account Support</span>
              </div>
              <div className="cq-trust-item">
                <span className="cq-trust-dot" />
                <span>Reliable and Timely Service</span>
              </div>
            </div>
          </aside>

          {/* ── Form card ── */}
          <div className="cq-card">

            <div className="cq-form-header">
    <h2>Request a Quote</h2>
    <p>
        Complete the form below and our commercial team
        will contact you.
    </p>
</div>

            {success && (
              <div className="cq-success">
              {success}
              </div>
            )}

            {error && (
              <div className="cq-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="cq-form">

              <div className="cq-row">
                <div className="cq-field">
                  <label>Company Name</label>
                  <input
                    type="text"
                    name="company_name"
                    placeholder="Acme Construction Pty Ltd"
                    value={form.company_name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="cq-field">
                  <label>Contact Person</label>
                  <input
                    type="text"
                    name="contact_person"
                    placeholder="Your full name"
                    value={form.contact_person}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="cq-row">
                <div className="cq-field">
                  <label>Business Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="you@company.com.au"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="cq-field">
                  <label>Phone Number</label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="04xx xxx xxx"
                    value={form.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="cq-field cq-field-full">
                <label>Project Location</label>
                <input
                  type="text"
                  name="project_location"
                  placeholder="Street address or suburb"
                  value={form.project_location}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="cq-row">
                <div className="cq-field">
                  <label>Bin Size</label>
                  <select name="bin_size" value={form.bin_size} onChange={handleChange} required>
                    <option value="">Select size</option>
                    <option value="2m3">2m³ Skip Bin</option>
                    <option value="3m3">3m³ Skip Bin</option>
                    <option value="4m3">4m³ Skip Bin</option>
                    <option value="6m3">6m³ Skip Bin</option>
                    <option value="8m3">8m³ Skip Bin</option>
                    <option value="10m3">10m³ Skip Bin</option>
                  </select>
                </div>
                <div className="cq-field">
                  <label>Waste Type</label>
                  <select name="waste_type" value={form.waste_type} onChange={handleChange} required>
                    <option value="">Select type</option>
                    <option value="General Waste">General Waste</option>
                    <option value="Green Waste">Green Waste</option>
                    <option value="Mixed Heavy Waste">Mixed Heavy Waste</option>
                    <option value="Soil & Dirt Waste">Soil & Dirt Waste</option>
                  </select>
                </div>
              </div>

              <div className="cq-field cq-field-full">
                <label>Project Requirements</label>
                <textarea
                  name="requirements"
                  placeholder="Describe your project — volume, timeline, frequency of collection, any special requirements..."
                  value={form.requirements}
                  onChange={handleChange}
                  rows="5"
                  required
                />
              </div>

              <button type="submit" className="cq-submit" disabled={loading}>
                {loading ? "Submitting…" : "Submit Quote Request"}
              </button>

            </form>

          </div>

        </div>

      </div>

      <Footer />
    </>
  );
};

export default CommercialQuote;